'use strict';

exports.__esModule = true;
exports['default'] = getLabel;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function getLabel(_ref) {
  var label = _ref.label;
  var htmlFor = _ref.htmlFor;
  var id = _ref.id;

  if (label) {
    return _react2['default'].createElement(
      'label',
      { htmlFor: htmlFor, id: id },
      label
    );
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb-form-templates-semantic/lib/getLabel.js
// module id = 65
// module chunks = 0